




































import { Vue, Component, Watch } from 'vue-property-decorator'
import Images from '@/data/images'
import RootNav, { Navigation, Nav, SubNav } from '@/data/nav'
import 'semantic-ui-css/components/container.min.css'
import 'semantic-ui-css/components/menu.min.css'
import 'semantic-ui-css/components/item.min.css'
import 'semantic-ui-css/components/icon.min.css'
import 'animate.css/source/fading_entrances/fadeInDown.css'
import 'animate.css/source/fading_exits/fadeOutUp.css'

function getSubNav (): SubNav | null {
  const subKey = document.URL.split('/')[3]
  return RootNav.subnavs[subKey] || null
}

@Component
export default class LCNavigation extends Vue {
  imgs = Images
  subNav: SubNav | null = getSubNav()
  subNavActive = Boolean(this.subNav)
  logo: string = this.subNav ? this.subNav.logo : Images.core.lcWhite
  activeNav: Nav | SubNav = this.subNav || RootNav
  mobileActive = false
  mobileClasses = null

  @Watch('$route.params.pathMatch')
  onPathChange (value: string) {
    const sub = RootNav.subnavs[value]

    if (sub) {
      const csub = this.subNav
      this.subNav = sub
      if (!csub) {
        this.logo = sub.logo
        this.subNavActive = true
        this.activeNav = this.subNav
      }
    } else {
      this.logo = Images.core.lcWhite
      this.subNav = null
      this.subNavActive = false
      this.activeNav = RootNav
    }
  }

  toggleSubNav () {
    this.subNavActive = !this.subNavActive
    if (!this.subNav) return

    if (this.subNavActive) {
      this.activeNav = this.subNav
      this.logo = this.subNav.logo
    } else {
      this.activeNav = RootNav
      this.logo = Images.core.lcWhite
    }
    this.mobileActive = true
  }
}
